import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CreditCardParameters } from '@/model/CreditCardParameters';

type CardValidationState = {
  creditCardParameters: CreditCardParameters;
};

const INITIAL_STATE: CardValidationState = {
  creditCardParameters: { openOnProfile: false, events: [] },
};

const cardValidationSlice = createSlice({
  name: 'cardValidation',
  initialState: INITIAL_STATE,
  reducers: {
    setCardValidation(state, { payload }: PayloadAction<CreditCardParameters>) {
      // eslint-disable-next-line no-param-reassign
      state.creditCardParameters = payload;
    },
  },
});

export const { setCardValidation } = cardValidationSlice.actions;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useCardValidation = (state: any): CardValidationState =>
  state.cardValidation as CardValidationState;

export default cardValidationSlice.reducer;
